export var convertLanguage = function (lang) {
    switch (lang) {
        case 'zh-TW':
            return 'zh-Hant-TW';
        case 'it':
            return 'en';
        case 'de':
            return 'en';
        case 'fr':
            return 'en';
        default:
            return lang;
    }
};
